export const getFilenameFromHeaders = (headers: Headers) => {
  const disposition = headers.get('content-disposition') || '';
  const filename = disposition.split('filename=')[1];
  return filename;
};
